/* eslint-disable quotes */
export default [
  "PROPCODE",
  "INTERNALHOTELCODE",
  "PROPNAME",
  "PROPADD1",
  "PROPADD2",
  "PROPCITY",
  "PROPSTATEPROV",
  "PROPCOUNTY",
  "PROPREGION",
  "PROPCOUNTRY",
  "PROPPOSTCODE",
  "MAINPHONECOUNTRY",
  "MAINPHONECITY",
  "MAINPHONE",
  "MAINFAXCOUNTRY",
  "MAINFAXCITY",
  "MAINFAX",
  "UNITOFMEAS",
  "PROPURL",
  "PROPSALESGENREMAIL",
  "FULL_OR_LIM",
  "ES_STAY",
  "MKT_TIER",
  "YRBUILT",
  "LASTREN",
  "NUMROOMS",
  "NUMNOSMK",
  "NUMFLRS",
  "MGMTCOMPANY",
  "OWNERCOMPANY",
  "PROPOVERVIEW",
  "PROP_LOC",
  "AIRCITYCODE",
  "AIR1CODE",
  "DISABCOMPLY",
  "DISABACCSS",
  "NUMDISABL",
  "HAND_PARK",
  "REST_ONSITE",
  "RM_SRV_AVL",
  "RM_SRV_HRS",
  "CONVENENCE_FOOD",
  "BUS_CENTER",
  "FRNT_DESK",
  "AIR_CONDITIONED",
  "PRIVATE_BATHSA",
  "AMEXCARD",
  "DINERSCARD",
  "DISCOVERCARD",
  "JCBCARD",
  "MASTERCARD",
  "VISACARD",
  "AMADEUS_CHAINCODE",
  "AMADEUS_PROPCODE",
  "APOLLO_CHAINCODE",
  "APOLLO_PROPCODE",
  "SABRE_CHAINCODE",
  "SABRE_PROPCODE",
  "WORLDSPAN_CHAINCODE",
  "WRLDSPAN_PROPCODE",
  "MASTERCHAINCODE",
  "CLIENT_NAME",
  "RM_NIGHTS",
  "RATE_CURR",
  "DYNAMIC_PRICING",
  "DYNAMIC_PCT_Discount",
  "ROOMTYPE1DEFINE",
  "ROOMTYPE1NUMBER",
  "ROOMTYPE2DEFINE",
  "ROOMTYPE2NUMBER",
  "ROOMTYPE3DEFINE",
  "ROOMTYPE3NUMBER",
  "SEASON1START",
  "SEASON1END",
  "LRA_S1_RT1_SGL",
  "LRA_S1_RT1_DBL",
  "LRA_S1_RT2_SGL",
  "LRA_S1_RT2_DBL",
  "LRA_S1_RT3_SGL",
  "LRA_S1_RT3_DBL",
  "NLRA_S1_RT1_SGL",
  "NLRA_S1_RT1_DBL",
  "NLRA_S1_RT2_SGL",
  "NLRA_S1_RT2_DBL",
  "NLRA_S1_RT3_SGL",
  "NLRA_S1_RT3_DBL",
  "GOVT_S1_RT1_SGL",
  "GOVT_S1_RT1_DBL",
  "GOVT_S1_RT2_SGL",
  "GOVT_S1_RT2_DBL",
  "GOVT_S1_RT3_SGL",
  "GOVT_S1_RT3_DBL",
  "SEASON2START",
  "SEASON2END",
  "LRA_S2_RT1_SGL",
  "LRA_S2_RT1_DBL",
  "LRA_S2_RT2_SGL",
  "LRA_S2_RT2_DBL",
  "LRA_S2_RT3_SGL",
  "LRA_S2_RT3_DBL",
  "NLRA_S2_RT1_SGL",
  "NLRA_S2_RT1_DBL",
  "NLRA_S2_RT2_SGL",
  "NLRA_S2_RT2_DBL",
  "NLRA_S2_RT3_SGL",
  "NLRA_S2_RT3_DBL",
  "GOVT_S2_RT1_SGL",
  "GOVT_S2_RT1_DBL",
  "GOVT_S2_RT2_SGL",
  "GOVT_S2_RT2_DBL",
  "GOVT_S2_RT3_SGL",
  "GOVT_S2_RT3_DBL",
  "SEASON3START",
  "SEASON3END",
  "LRA_S3_RT1_SGL",
  "LRA_S3_RT1_DBL",
  "LRA_S3_RT2_SGL",
  "LRA_S3_RT2_DBL",
  "LRA_S3_RT3_SGL",
  "LRA_S3_RT3_DBL",
  "NLRA_S3_RT1_SGL",
  "NLRA_S3_RT1_DBL",
  "NLRA_S3_RT2_SGL",
  "NLRA_S3_RT2_DBL",
  "NLRA_S3_RT3_SGL",
  "NLRA_S3_RT3_DBL",
  "GOVT_S3_RT1_SGL",
  "GOVT_S3_RT1_DBL",
  "GOVT_S3_RT2_SGL",
  "GOVT_S3_RT2_DBL",
  "GOVT_S3_RT3_SGL",
  "GOVT_S3_RT3_DBL",
  "SEASON4START",
  "SEASON4END",
  "LRA_S4_RT1_SGL",
  "LRA_S4_RT1_DBL",
  "LRA_S4_RT2_SGL",
  "LRA_S4_RT2_DBL",
  "LRA_S4_RT3_SGL",
  "LRA_S4_RT3_DBL",
  "NLRA_S4_RT1_SGL",
  "NLRA_S4_RT1_DBL",
  "NLRA_S4_RT2_SGL",
  "NLRA_S4_RT2_DBL",
  "NLRA_S4_RT3_SGL",
  "NLRA_S4_RT3_DBL",
  "GOVT_S4_RT1_SGL",
  "GOVT_S4_RT1_DBL",
  "GOVT_S4_RT2_SGL",
  "GOVT_S4_RT2_DBL",
  "GOVT_S4_RT3_SGL",
  "GOVT_S4_RT3_DBL",
  "SEASON5START",
  "SEASON5END",
  "LRA_S5_RT1_SGL",
  "LRA_S5_RT1_DBL",
  "LRA_S5_RT2_SGL",
  "LRA_S5_RT2_DBL",
  "LRA_S5_RT3_SGL",
  "LRA_S5_RT3_DBL",
  "NLRA_S5_RT1_SGL",
  "NLRA_S5_RT1_DBL",
  "NLRA_S5_RT2_SGL",
  "NLRA_S5_RT2_DBL",
  "NLRA_S5_RT3_SGL",
  "NLRA_S5_RT3_DBL",
  "GOVT_S5_RT1_SGL",
  "GOVT_S5_RT1_DBL",
  "GOVT_S5_RT2_SGL",
  "GOVT_S5_RT2_DBL",
  "GOVT_S5_RT3_SGL",
  "GOVT_S5_RT3_DBL",
  "COMMISSIONABLE",
  "COMM_PCT_CLIENT",
  "LOAD_GDS",
  "WALK_HOTEL",
  "WALK_TAX",
  "WALK_TRANS",
  "WALK_CALL",
  "CANC_POL",
  "EARLYCK_FEE",
  "EARLYCK_UOM",
  "EARLYCK_INCLUDE",
  "LODGTX_FEE",
  "LODGTX_UOM",
  "LODGTX_INCLUDE",
  "STATETX_FEE",
  "STATETX_UOM",
  "STATETX_INCLUDE",
  "CITYTX_FEE",
  "CITYTX_UOM",
  "CITYTX_INCLUDE",
  "VATGSTRM_FEE",
  "VATGSTRM_UOM",
  "VATGSTRM_INCLUDE",
  "VATGSTFB_FEE",
  "VATGSTFB_UOM",
  "VATGSTFB_INCLUDE",
  "SERVICE_FEE",
  "SERVICE_UOM",
  "SERVICE_INCLUDE",
  "OCC_FEE",
  "OCC_UOM",
  "OCC_INCLUDE",
  "OTHERTX_FEE",
  "OTHERTX_FEE_UOM",
  "OTHERTX_FEE_DESC",
  "OTHERTX_FEE_INCL",
  "PARKATTEND",
  "PARK_FEE",
  "PARK_INCLUDE",
  "BREAK_INCLUDE",
  "BREAK_FEE",
  "BREAK_TYPE",
  "FITON_CENT",
  "FITNESS_FEE_ON",
  "FITNESS_INCLUDE_ON",
  "LOCAL_PHONE_INCLUDE",
  "TOLL_CARD_CALL_INCLUDE",
  "HIGHSPEED_INROOM",
  "HIGHSPEED_INROOM_NUM",
  "HSIA_FEE",
  "HSIA_INCLUDE",
  "WIRELESS",
  "WIRELESS_NUM",
  "WIRELESS_FEE",
  "WIRELESS_INCLUDE",
  "AIRTRANS_FEE",
  "AIRTRANS_INCLUDE",
  "AIRTRANS_DESCRIBE",
  "OFFTRANS_INCLUDE",
  "RATE_SUBS",
  "RATE_PERSO",
  "RATE_CONSU",
  "RATE_RETIR",
  "RFP_CONTRACT",
  "RFP_NAME",
  "RFP_TITLE",
  "RFP_PHONECOUNTRYCODE",
  "RFP_PHONECITYCODE",
  "RFP_PHONE",
  "RFP_EMAIL",
  "RFP_DATESUBMIT",
  "USERDEFINED1",
  "USERDEFINED2",
  "USERDEFINED3",
  "USERDEFINED4",
  "USERDEFINED5",
  "USERDEFINED6",
  "USERDEFINED7",
  "USERDEFINED8",
  "USERDEFINED9",
  "USERDEFINED10",
  "USERDEFINED11",
  "USERDEFINED12",
  "USERDEFINED13",
  "USERDEFINED14",
  "USERDEFINED15",
  "USERDEFINED16",
  "USERDEFINED17",
  "USERDEFINED18",
  "USERDEFINED19",
  "USERDEFINED20",
  "USERDEFINED21",
  "USERDEFINED22",
  "USERDEFINED23",
  "USERDEFINED24",
  "USERDEFINED25",
  "USERDEFINED26",
  "USERDEFINED27",
  "USERDEFINED28",
  "USERDEFINED29",
  "USERDEFINED30",
  "IN_SAFE",
  "LAPTOP_SAFE",
  "ROOMSMKDET",
  "HALLSMKDET",
  "PUBSMKDET",
  "HRDWIREDET",
  "FIRE_EXTIN",
  "EMRGCYLITE",
  "VENT_STAIR",
  "EVACPLAN",
  "FIRELAWS",
  "VIS_ALARM",
  "HALLVIS_ALARM",
  "PUBVIS_ALARM",
  "AUD_ALARM",
  "HALLAUD_ALARM",
  "PUBAUD_ALARM",
  "ROOMSPRINK",
  "HALLSPRINK",
  "PUBSPRINK",
  "EMRGCYINFO",
  "FIRE_LINK",
  "MULT_EXITS",
  "AUTO_RECAL",
  "SECURITY",
  "SECUR_HRS",
  "DEADBOLTS",
  "INT_ACCESS",
  "DOORS_CLOSE",
  "OPEN_WINDOWS",
  "PUBADDRESS",
  "SAFE_CODES",
  "PARKGATES",
  "PARKPATROL",
  "PARKLIGHTS",
  "PUBCAMERA",
  "PARK_FR_ENT",
  "PARK_CAMERA",
  "CAMERA_REC_24HR",
  "CAMERA_MONT_24HR",
  "VIEWPORTS",
  "BACK_UP",
  "EXT_DOOR_KEY_ACCESS",
  "STAFF_AID",
  "STAFF_CPR_TRAIN",
  "STAFF_CPR_CERT",
  "AED_ONSITE",
  "STAFF_AED",
  "KEY_ID",
  "KEY_ELEVATOR",
  "KEY_PUBLIC",
  "LASTROOMAVAIL_BD",
  "BD1_START",
  "BD1_END",
  "BD1_NAME",
  "BD1_RT1_SGL",
  "BD1_RT1_DBL",
  "BD1_RT2_SGL",
  "BD1_RT2_DBL",
  "BD1_RT3_SGL",
  "BD1_RT3_DBL",
  "BD2_START",
  "BD2_END",
  "BD2_NAME",
  "BD2_RT1_SGL",
  "BD2_RT1_DBL",
  "BD2_RT2_SGL",
  "BD2_RT2_DBL",
  "BD2_RT3_SGL",
  "BD2_RT3_DBL",
  "BD3_START",
  "BD3_END",
  "BD3_NAME",
  "BD3_RT1_SGL",
  "BD3_RT1_DBL",
  "BD3_RT2_SGL",
  "BD3_RT2_DBL",
  "BD3_RT3_SGL",
  "BD3_RT3_DBL",
  "BD4_START",
  "BD4_END",
  "BD4_NAME",
  "BD4_RT1_SGL",
  "BD4_RT1_DBL",
  "BD4_RT2_SGL",
  "BD4_RT2_DBL",
  "BD4_RT3_SGL",
  "BD4_RT3_DBL",
  "BD5_START",
  "BD5_END",
  "BD5_NAME",
  "BD5_RT1_SGL",
  "BD5_RT1_DBL",
  "BD5_RT2_SGL",
  "BD5_RT2_DBL",
  "BD5_RT3_SGL",
  "BD5_RT3_DBL",
  "BD6_START",
  "BD6_END",
  "BD6_NAME",
  "BD6_RT1_SGL",
  "BD6_RT1_DBL",
  "BD6_RT2_SGL",
  "BD6_RT2_DBL",
  "BD6_RT3_SGL",
  "BD6_RT3_DBL",
  "BD7_START",
  "BD7_END",
  "BD7_NAME",
  "BD7_RT1_SGL",
  "BD7_RT1_DBL",
  "BD7_RT2_SGL",
  "BD7_RT2_DBL",
  "BD7_RT3_SGL",
  "BD7_RT3_DBL",
  "BD8_START",
  "BD8_END",
  "BD8_NAME",
  "BD8_RT1_SGL",
  "BD8_RT1_DBL",
  "BD8_RT2_SGL",
  "BD8_RT2_DBL",
  "BD8_RT3_SGL",
  "BD8_RT3_DBL",
  "BD9_START",
  "BD9_END",
  "BD9_NAME",
  "BD9_RT1_SGL",
  "BD9_RT1_DBL",
  "BD9_RT2_SGL",
  "BD9_RT2_DBL",
  "BD9_RT3_SGL",
  "BD9_RT3_DBL",
  "BD10_START",
  "BD10_END",
  "BD10_NAME",
  "BD10_RT1_SGL",
  "BD10_RT1_DBL",
  "BD10_RT2_SGL",
  "BD10_RT2_DBL",
  "BD10_RT3_SGL",
  "BD10_RT3_DBL",
  "GROCERY_SVC",
  "STORAGE",
  "STORAGE_FEE",
  "LAUN_DRY",
  "LAUNDRY_SITE",
  "MINI_FRIG",
  "MICRO",
  "COFF_TEA",
  "STOVE",
  "OVEN",
  "TOASTER",
  "DINING_WARE",
  "DISHES",
  "HOUSEKEEPING",
  "HOUSE_CHARGE",
  "LOS2MIN_ES",
  "LOS2MAX_ES",
  "LOS3MIN_ES",
  "LOS3MAX_ES",
  "LOS4MIN_ES",
  "LOS4MAX_ES",
  "SEASON1START_ES",
  "SEASON1END_ES",
  "LRA_S1_RT1_L2_ES_SGL",
  "LRA_S1_RT1_L2_ES_DBL",
  "LRA_S1_RT2_L2_ES_SGL",
  "LRA_S1_RT2_L2_ES_DBL",
  "LRA_S1_RT3_L2_ES_SGL",
  "LRA_S1_RT3_L2_ES_DBL",
  "NLRA_S1_RT1_L2_ES_SGL",
  "NLRA_S1_RT1_L2_ES_DBL",
  "NLRA_S1_RT2_L2_ES_SGL",
  "NLRA_S1_RT2_L2_ES_DBL",
  "NLRA_S1_RT3_L2_ES_SGL",
  "NLRA_S1_RT3_L2_ES_DBL",
  "LRA_S1_RT1_L3_ES_SGL",
  "LRA_S1_RT1_L3_ES_DBL",
  "LRA_S1_RT2_L3_ES_SGL",
  "LRA_S1_RT2_L3_ES_DBL",
  "LRA_S1_RT3_L3_ES_SGL",
  "LRA_S1_RT3_L3_ES_DBL",
  "NLRA_S1_RT1_L3_ES_SGL",
  "NLRA_S1_RT1_L3_ES_DBL",
  "NLRA_S1_RT2_L3_ES_SGL",
  "NLRA_S1_RT2_L3_ES_DBL",
  "NLRA_S1_RT3_L3_ES_SGL",
  "NLRA_S1_RT3_L3_ES_DBL",
  "LRA_S1_RT1_L4_ES_SGL",
  "LRA_S1_RT1_L4_ES_DBL",
  "LRA_S1_RT2_L4_ES_SGL",
  "LRA_S1_RT2_L4_ES_DBL",
  "LRA_S1_RT3_L4_ES_SGL",
  "LRA_S1_RT3_L4_ES_DBL",
  "NLRA_S1_RT1_L4_ES_SGL",
  "NLRA_S1_RT1_L4_ES_DBL",
  "NLRA_S1_RT2_L4_ES_SGL",
  "NLRA_S1_RT2_L4_ES_DBL",
  "NLRA_S1_RT3_L4_ES_SGL",
  "NLRA_S1_RT3_L4_ES_DBL",
  "SEASON2START_ES",
  "SEASON2END_ES",
  "LRA_S2_RT1_L2_ES_SGL",
  "LRA_S2_RT1_L2_ES_DBL",
  "LRA_S2_RT2_L2_ES_SGL",
  "LRA_S2_RT2_L2_ES_DBL",
  "LRA_S2_RT3_L2_ES_SGL",
  "LRA_S2_RT3_L2_ES_DBL",
  "NLRA_S2_RT1_L2_ES_SGL",
  "NLRA_S2_RT1_L2_ES_DBL",
  "NLRA_S2_RT2_L2_ES_SGL",
  "NLRA_S2_RT2_L2_ES_DBL",
  "NLRA_S2_RT3_L2_ES_SGL",
  "NLRA_S2_RT3_L2_ES_DBL",
  "LRA_S2_RT1_L3_ES_SGL",
  "LRA_S2_RT1_L3_ES_DBL",
  "LRA_S2_RT2_L3_ES_SGL",
  "LRA_S2_RT2_L3_ES_DBL",
  "LRA_S2_RT3_L3_ES_SGL",
  "LRA_S2_RT3_L3_ES_DBL",
  "NLRA_S2_RT1_L3_ES_SGL",
  "NLRA_S2_RT1_L3_ES_DBL",
  "NLRA_S2_RT2_L3_ES_SGL",
  "NLRA_S2_RT2_L3_ES_DBL",
  "NLRA_S2_RT3_L3_ES_SGL",
  "NLRA_S2_RT3_L3_ES_DBL",
  "LRA_S2_RT1_L4_ES_SGL",
  "LRA_S2_RT1_L4_ES_DBL",
  "LRA_S2_RT2_L4_ES_SGL",
  "LRA_S2_RT2_L4_ES_DBL",
  "LRA_S2_RT3_L4_ES_SGL",
  "LRA_S2_RT3_L4_ES_DBL",
  "NLRA_S2_RT1_L4_ES_SGL",
  "NLRA_S2_RT1_L4_ES_DBL",
  "NLRA_S2_RT2_L4_ES_SGL",
  "NLRA_S2_RT2_L4_ES_DBL",
  "NLRA_S2_RT3_L4_ES_SGL",
  "NLRA_S2_RT3_L4_ES_DBL",
  "SEASON3START_ES",
  "SEASON3END_ES",
  "LRA_S3_RT1_L2_ES_SGL",
  "LRA_S3_RT1_L2_ES_DBL",
  "LRA_S3_RT2_L2_ES_SGL",
  "LRA_S3_RT2_L2_ES_DBL",
  "LRA_S3_RT3_L2_ES_SGL",
  "LRA_S3_RT3_L2_ES_DBL",
  "NLRA_S3_RT1_L2_ES_SGL",
  "NLRA_S3_RT1_L2_ES_DBL",
  "NLRA_S3_RT2_L2_ES_SGL",
  "NLRA_S3_RT2_L2_ES_DBL",
  "NLRA_S3_RT3_L2_ES_SGL",
  "NLRA_S3_RT3_L2_ES_DBL",
  "LRA_S3_RT1_L3_ES_SGL",
  "LRA_S3_RT1_L3_ES_DBL",
  "LRA_S3_RT2_L3_ES_SGL",
  "LRA_S3_RT2_L3_ES_DBL",
  "LRA_S3_RT3_L3_ES_SGL",
  "LRA_S3_RT3_L3_ES_DBL",
  "NLRA_S3_RT1_L3_ES_SGL",
  "NLRA_S3_RT1_L3_ES_DBL",
  "NLRA_S3_RT2_L3_ES_SGL",
  "NLRA_S3_RT2_L3_ES_DBL",
  "NLRA_S3_RT3_L3_ES_SGL",
  "NLRA_S3_RT3_L3_ES_DBL",
  "LRA_S3_RT1_L4_ES_SGL",
  "LRA_S3_RT1_L4_ES_DBL",
  "LRA_S3_RT2_L4_ES_SGL",
  "LRA_S3_RT2_L4_ES_DBL",
  "LRA_S3_RT3_L4_ES_SGL",
  "LRA_S3_RT3_L4_ES_DBL",
  "NLRA_S3_RT1_L4_ES_SGL",
  "NLRA_S3_RT1_L4_ES_DBL",
  "NLRA_S3_RT2_L4_ES_SGL",
  "NLRA_S3_RT2_L4_ES_DBL",
  "NLRA_S3_RT3_L4_ES_SGL",
  "NLRA_S3_RT3_L4_ES_DBL",
  "SEASON4START_ES",
  "SEASON4END_ES",
  "LRA_S4_RT1_L2_ES_SGL",
  "LRA_S4_RT1_L2_ES_DBL",
  "LRA_S4_RT2_L2_ES_SGL",
  "LRA_S4_RT2_L2_ES_DBL",
  "LRA_S4_RT3_L2_ES_SGL",
  "LRA_S4_RT3_L2_ES_DBL",
  "NLRA_S4_RT1_L2_ES_SGL",
  "NLRA_S4_RT1_L2_ES_DBL",
  "NLRA_S4_RT2_L2_ES_SGL",
  "NLRA_S4_RT2_L2_ES_DBL",
  "NLRA_S4_RT3_L2_ES_SGL",
  "NLRA_S4_RT3_L2_ES_DBL",
  "LRA_S4_RT1_L3_ES_SGL",
  "LRA_S4_RT1_L3_ES_DBL",
  "LRA_S4_RT2_L3_ES_SGL",
  "LRA_S4_RT2_L3_ES_DBL",
  "LRA_S4_RT3_L3_ES_SGL",
  "LRA_S4_RT3_L3_ES_DBL",
  "NLRA_S4_RT1_L3_ES_SGL",
  "NLRA_S4_RT1_L3_ES_DBL",
  "NLRA_S4_RT2_L3_ES_SGL",
  "NLRA_S4_RT2_L3_ES_DBL",
  "NLRA_S4_RT3_L3_ES_SGL",
  "NLRA_S4_RT3_L3_ES_DBL",
  "LRA_S4_RT1_L4_ES_SGL",
  "LRA_S4_RT1_L4_ES_DBL",
  "LRA_S4_RT2_L4_ES_SGL",
  "LRA_S4_RT2_L4_ES_DBL",
  "LRA_S4_RT3_L4_ES_SGL",
  "LRA_S4_RT3_L4_ES_DBL",
  "NLRA_S4_RT1_L4_ES_SGL",
  "NLRA_S4_RT1_L4_ES_DBL",
  "NLRA_S4_RT2_L4_ES_SGL",
  "NLRA_S4_RT2_L4_ES_DBL",
  "NLRA_S4_RT3_L4_ES_SGL",
  "NLRA_S4_RT3_L4_ES_DBL",
  "SEASON5START_ES",
  "SEASON5END_ES",
  "LRA_S5_RT1_L2_ES_SGL",
  "LRA_S5_RT1_L2_ES_DBL",
  "LRA_S5_RT2_L2_ES_SGL",
  "LRA_S5_RT2_L2_ES_DBL",
  "LRA_S5_RT3_L2_ES_SGL",
  "LRA_S5_RT3_L2_ES_DBL",
  "NLRA_S5_RT1_L2_ES_SGL",
  "NLRA_S5_RT1_L2_ES_DBL",
  "NLRA_S5_RT2_L2_ES_SGL",
  "NLRA_S5_RT2_L2_ES_DBL",
  "NLRA_S5_RT3_L2_ES_SGL",
  "NLRA_S5_RT3_L2_ES_DBL",
  "LRA_S5_RT1_L3_ES_SGL",
  "LRA_S5_RT1_L3_ES_DBL",
  "LRA_S5_RT2_L3_ES_SGL",
  "LRA_S5_RT2_L3_ES_DBL",
  "LRA_S5_RT3_L3_ES_SGL",
  "LRA_S5_RT3_L3_ES_DBL",
  "NLRA_S5_RT1_L3_ES_SGL",
  "NLRA_S5_RT1_L3_ES_DBL",
  "NLRA_S5_RT2_L3_ES_SGL",
  "NLRA_S5_RT2_L3_ES_DBL",
  "NLRA_S5_RT3_L3_ES_SGL",
  "NLRA_S5_RT3_L3_ES_DBL",
  "LRA_S5_RT1_L4_ES_SGL",
  "LRA_S5_RT1_L4_ES_DBL",
  "LRA_S5_RT2_L4_ES_SGL",
  "LRA_S5_RT2_L4_ES_DBL",
  "LRA_S5_RT3_L4_ES_SGL",
  "LRA_S5_RT3_L4_ES_DBL",
  "NLRA_S5_RT1_L4_ES_SGL",
  "NLRA_S5_RT1_L4_ES_DBL",
  "NLRA_S5_RT2_L4_ES_SGL",
  "NLRA_S5_RT2_L4_ES_DBL",
  "NLRA_S5_RT3_L4_ES_SGL",
  "NLRA_S5_RT3_L4_ES_DBL",
  "ADDTL_CHARGE_R1_ES",
  "ADDTL_CHARGE_R2_ES",
  "ADDTL_CHARGE_R3_ES",
  "LOS_OCC_ES",
  "RATE_NOTES_ES",
  "ADDL_SVC_ES",
  "GROUPUNITOFMEAS",
  "MTGSPACE",
  "MTGROOMS",
  "LGST_MTGRM",
  "BOARDROOM",
  "MTG_TAX_AMT",
  "MTG_TAX_UOM",
  "MTG_TAX_INCL",
  "MTG_SERVICE_AMT",
  "MTG_SERVICE_UOM",
  "MTG_SERVICE_INCL",
  "BREAKOUT_10",
  "BREAKOUT_25",
  "GROUP_S1_10-50",
  "GROUP_S1_51-100",
  "GROUP_S2_10-50",
  "GROUP_S2_51-100",
  "GROUP_S3_10-50",
  "GROUP_S3_51-100",
  "GROUP_S4_10-50",
  "GROUP_S4_51-100",
  "GROUP_S5_10-50",
  "GROUP_S5_51-100",
  "MTGPKG_FULL_10-50",
  "MTGPKG_HALF_10-50",
  "MTGPKG_FULL_51-100",
  "MTGPKG_HALF_51-100",
  "PARK_COMP_MTG",
  "AV_SUPPLIER",
  "LCD_COST",
  "LCD_INCL",
  "SCREEN_COST",
  "SCREEN_INCL",
  "HSIA_COST_MTG",
  "HSIA_INCL_MTG",
  "MTG_UserDefined1",
  "MTG_UserDefined2",
  "MTG_UserDefined3",
  "MTG_UserDefined4",
  "MTG_UserDefined5",
  "MTG_UserDefined6",
  "MTG_UserDefined7",
  "MTG_UserDefined8",
  "MTG_UserDefined9",
  "MTG_UserDefined10",
  "MTG_UserDefined11",
  "MTG_UserDefined12",
  "MTG_UserDefined13",
  "MTG_UserDefined14",
  "MTG_UserDefined15",
  "MTG_UserDefined16",
  "MTG_UserDefined17",
  "MTG_UserDefined18",
  "MTG_UserDefined19",
  "MTG_UserDefined20",
  "MTG_UserDefined21",
  "MTG_UserDefined22",
  "MTG_UserDefined23",
  "MTG_UserDefined24",
  "MTG_UserDefined25",
  "MTG_UserDefined26",
  "MTG_UserDefined27",
  "MTG_UserDefined28",
  "MTG_UserDefined29",
  "MTG_UserDefined30",
  "CSR_CERTIFIED",
  "CSR_CERTIFIED_BY",
  "CSR_CERTIFIED_AUDIT",
  "MEAS_CARBON",
  "MEAS_CARBON_AMT",
  "MEAS_CARBON_UOM",
  "MEAS_CARBON_PD",
  "MEAS_WATER_PRN",
  "MEAS_WATER_AMT",
  "MEAS_WATER_UOM",
  "MEAS_WATER_PD",
  "MEAS_ENERGY",
  "MEAS_ENERGY_AMT",
  "MEAS_ENERGY_UOM",
  "MEAS_ENERGY_PD",
  "MEAS_WASTE",
  "MEAS_WASTE_PCT",
  "MEAS_WASTE_PD",
  "ENVIRO_CSR",
  "ENVIRO_CSR_PROGRAM"
];
